import Taro from '@tarojs/taro';

export function makePhoneCell ({tel}) {
  return Taro.makePhoneCall({ phoneNumber: String(tel) })
}

export function setStorage (keyName, value) {
  return Taro.setStorage({
    key: keyName,
    data: value
  })
}

export function getStorage (keyName) {
  let value = '';
  Taro.getStorage({
    key: keyName,
    success: function (res) {
      value = res.data
    }
  }).catch((e) => {
    console.log(e, `${keyName}: getStorage error`);
  });
  return value;
}
